<div class="content d-flex flex-column flex-column-fluid" id="kt_content">
    <div class="toolbar mb-5">
        <div class="container-fluid d-flex flex-stack">
            <div class="page-title d-flex flex-column align-items-start me-3 mb-5 mb-lg-0">
                <h3 class="d-flex text-dark fw-bolder fs-3 flex-column mb-0">
                    <span><i class="fas fa-tasks text-success me-2" style="font-size: large;"></i><span></span> Anasayfa </span>
                </h3>
            </div>
            <div class="d-flex align-items-center gap-2 gap-lg-3">
            </div>
        </div>
    </div>
<div id="kt_content_container" class="mx-10 justify-content-center">

<div class="row gy-5 g-xl-10">    
    <!--begin::Col-->
    <div class="col-xxl-6">
        <!--begin::Row-->
        <div class="row gx-5 gx-xl-10">
            <!--begin::Col-->
            <div class="col-sm-12 mb-5 mb-xl-10" > 
                <!--begin::List widget 1-->
                <div class="card card-flush h-lg-100">
                    <!--begin::Header-->
                    <div class="card-header pt-5" style="border-top: 2px blue solid;">
                        <!--begin::Title-->
                        <h3 class="card-title align-items-start flex-column">
                            <span class="card-label fw-bolder text-dark"><i class="far fa-address-book text-success me-2" style="font-size: larger;"></i> <b>Talep Özeti</b></span>
                            <span class="text-gray-400 mt-1 fw-bold fs-6">İstatislikler</span>
                        </h3>
                        <!--end::Title-->
                        <!--begin::Toolbar-->
                        <div class="card-toolbar">
                            <!--begin::Menu-->
                            <button class="btn btn-icon btn-color-gray-400 btn-active-color-primary justify-content-end" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end" data-kt-menu-overflow="true">
                                <!--begin::Svg Icon | path: icons/duotune/general/gen023.svg-->
                                <span class="svg-icon svg-icon-1">
                                  
                                </span>
                                <!--end::Svg Icon-->
                            </button>
                            <!--begin::Menu 2-->
                        
                            <!--end::Menu 2-->
                            <!--end::Menu-->
                        </div>
                        <!--end::Toolbar-->
                    </div>
                    <!--end::Header-->
                    <!--begin::Body-->
                    <div class="card-body pt-5">
                        <!--begin::Item-->
                        <div class="d-flex flex-stack">
                            <!--begin::Section-->
                            <div class="text-gray-700 fw-bold fs-6 me-2">
                                <a  routerLink="/talep-list" class="fw-bolder text-gray-800 text-hover-primary fs-6">Bekleyen</a>
                                </div>
                            <!--end::Section-->
                            <!--begin::Statistics-->
                            <div class="d-flex align-items-senter">
                                <!--begin::Svg Icon | path: icons/duotune/arrows/arr094.svg-->
                                <span class="svg-icon svg-icon-2 svg-icon-success me-2">
                                    <i class="fas fa-pause text-warning me-2"></i>
                                </span>
                                <!--end::Svg Icon-->
                                <!--begin::Number-->
                                <span class="text-gray-900 fw-boldest fs-6">{{anasayfaBilgi?.bekleyen}}</span>
                                <!--end::Number-->
                               
                            </div>
                            <!--end::Statistics-->
                        </div>
                        <!--end::Item-->
                        <!--end::Separator-->
                        <!--begin::Item-->
                        <div class="separator separator-dashed my-3"></div>
                        <!--end::Separator-->
                        <!--begin::Item-->
                        <div class="d-flex flex-stack">
                            <!--begin::Section-->
                            <div class="text-gray-700 fw-bold fs-6 me-2">
                                <a  routerLink="/talep-list" class="fw-bolder text-gray-800 text-hover-primary fs-6">Kapatılmış</a>
                                </div>
                            <!--end::Section-->
                            <!--begin::Statistics-->
                            <div class="d-flex align-items-senter">
                                <!--begin::Svg Icon | path: icons/duotune/arrows/arr094.svg-->
                                <span class="svg-icon svg-icon-2 svg-icon-success me-2">
                                    <i class="fas fa-check text-success me-2"></i>
                                </span>
                                <!--end::Svg Icon-->
                                <!--begin::Number-->
                                <span class="text-gray-900 fw-boldest fs-6">{{anasayfaBilgi?.kapatilmis}}</span>
                                <!--end::Number-->
                            </div>
                            <!--end::Statistics-->
                        </div>
                        <div class="separator separator-dashed my-3"></div>
                        <div class="d-flex flex-stack">
                            <!--begin::Section-->
                            <div class="text-gray-700 fw-bold fs-6 me-2">
                                <a  routerLink="/talep-list" class="fw-bolder text-gray-800 text-hover-primary fs-6">Toplam</a>
                                </div>
                            <!--end::Section-->
                            <!--begin::Statistics-->
                            <div class="d-flex align-items-senter">
                                <!--begin::Svg Icon | path: icons/duotune/arrows/arr094.svg-->
                                <span class="svg-icon svg-icon-2 svg-icon-success me-2">
                                    <i class="fas fa-plus text-success me-2"></i>
                                </span>
                                <!--end::Svg Icon-->
                                <!--begin::Number-->
                                <span class="text-gray-900 fw-boldest fs-6">{{anasayfaBilgi?.toplam}}</span>
                                <!--end::Number-->
                            </div>
                            <!--end::Statistics-->
                        </div>
                        <!--end::Item-->
                    </div>
                    <!--end::Body-->
                </div>
                <!--end::LIst widget 1-->
            </div>
            <!--end::Col-->
            <!--begin::Col-->
            
            <!--end::Col-->
        </div>
        <!--end::Row-->
        <!--begin::Tables widget 1-->
        <div class="row gx-5 gx-xl-10">
            <!--begin::Col-->
            <div class="col-sm-12 mb-5 mb-xl-10" > 
                <!--begin::List widget 1-->
                <div class="card card-flush h-lg-100">
                    <!--begin::Header-->
                    <div class="card-header pt-5" style="border-top: 2px red solid;">
                        <!--begin::Title-->
                        <h3 class="card-title align-items-start flex-column">
                            <span class="card-label fw-bolder text-dark">  <i class="fas fa-book text-danger me-2" style="font-size: large;" ></i><b>Açıklamalar</b></span>
                            
                        </h3>
                        <!--end::Title-->
                        <!--begin::Toolbar-->
                        <div class="card-toolbar">
                            <!--begin::Menu-->
                            <button class="btn btn-icon btn-color-gray-400 btn-active-color-primary justify-content-end" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end" data-kt-menu-overflow="true">
                                <!--begin::Svg Icon | path: icons/duotune/general/gen023.svg-->
                                <span class="svg-icon svg-icon-1">
                                  
                                </span>
                                <!--end::Svg Icon-->
                            </button>
                            <!--begin::Menu 2-->
                        
                            <!--end::Menu 2-->
                            <!--end::Menu-->
                        </div>
                        <!--end::Toolbar-->
                    </div>
                    <!--end::Header-->
                    <!--begin::Body-->
                    <div class="card-body pt-2" style="font-size: larger;">
                        <!--begin::Item-->
                        <div class="d-flex align-items-center bg-light-danger rounded mb-3">
                            <!--begin::Icon-->
                            <span class="svg-icon svg-icon-danger me-5">
                                <!--begin::Svg Icon | path: icons/duotune/abstract/abs027.svg-->
                                <span class="svg-icon svg-icon-1">
                                    <i class="far fa-hand-point-right" style="font-size: large; color: red;"></i>
                                </span>
                                <!--end::Svg Icon-->
                            </span>
                            <!--end::Icon-->
                            <!--begin::Title-->
                            <div class="flex-grow-1 me-2">
                                <span  class=" text-gray-800  fs-5">Profil ve iletişim bilgileriniz tamamlanmadan talepte bulunamazsınız ! <a routerLink="/profil">Profil Bilgilerim</a>  kısmından bilgilerinizi tamamlayınız ( <b>Öğrenci e-postanızı da Profil Bilgilerim kısmından öğrenebilirsiniz. </b>).</span>
                                <span class="text-muted fw-bold d-block"></span>
                                <span class="text-muted fw-bold d-block fs-6">
                                    Tamamlama Oranı ( % {{anasayfaBilgi?.profilTamamlanmaOrani}})
                                    <div class="progress">
                                        <div class="progress-bar " role="progressbar" [style.width.%]="anasayfaBilgi?.profilTamamlanmaOrani" aria-valuenow="100" aria-valuemin="1" aria-valuemax="100"></div>
                                    </div>
                                </span>
                            </div>

                            <!--end::Title-->
                            <!--begin::Lable-->
                            <span class="fw-bolder text-danger py-1"></span>      
                            <!--end::Lable-->
                        </div>

                        <div class="d-flex align-items-center bg-light-success rounded mb-3">
                            <!--begin::Icon-->
                            <span class="svg-icon svg-icon-danger me-5">
                                <!--begin::Svg Icon | path: icons/duotune/abstract/abs027.svg-->
                                <span class="svg-icon svg-icon-1">
                                    <i class="far fa-hand-point-right" style="font-size: large; color: red;"></i>
                                </span>
                                <!--end::Svg Icon-->
                            </span>
                            <!--end::Icon-->
                            <!--begin::Title-->
                            <div class="flex-grow-1 me-2">
                                <span  class=" text-gray-800  fs-5">Süreci devam eden en fazla <b>3</b> ayrı talepte bulunabilirsiniz.</span>
                                <span class="text-muted fw-bold d-block"></span>
                            </div>

                            <!--end::Title-->
                            <!--begin::Lable-->
                            <span class="fw-bolder text-danger py-1"></span>             
                            <!--end::Lable-->
                        </div>   
                        
                        <div class="d-flex align-items-center bg-light-info rounded ">
                            <!--begin::Icon-->
                            <span class="svg-icon svg-icon-danger me-5">
                                <!--begin::Svg Icon | path: icons/duotune/abstract/abs027.svg-->
                                <span class="svg-icon svg-icon-1">
                                    <i class="far fa-hand-point-right" style="font-size: large; color: red;"></i>
                                </span>
                                <!--end::Svg Icon-->
                            </span>
                            <!--end::Icon-->
                            <!--begin::Title-->
                            <div class="flex-grow-1 me-2">
                                <span  class=" text-gray-800  fs-5">Talepleriniz ile ilgili süreçleri <b>
                                    <a  routerLink="/talep-list" class="fw-bolder text-gray-800 text-hover-info fs-6">Talep İşlemleri -> Talep Listesi</a></b> ekranından takip edebilirsiniz.</span>
                                <span class="text-muted fw-bold d-block"></span>
                            </div>

                            <!--end::Title-->
                            <!--begin::Lable-->
                            <span class="fw-bolder text-danger py-1"></span>             
                            <!--end::Lable-->
                        </div>   
                        <!--end::Item-->
                        <!--begin::Separator-->                
                        <!--end::Item-->
                    </div>
                    <!--end::Body-->
                </div>
                <!--end::LIst widget 1-->
            </div>
            <!--end::Col-->
            <!--begin::Col-->
            
            <!--end::Col-->
        </div>
        <!--end::Tables widget 1-->
    </div>
    <!--end::Col-->
    <!--begin::Col-->
    <div class="col-xxl-6 mb-5 mb-xl-10" >
        <!--begin::Chart widget 8-->
        <div class="card card-flush h-xl-100" style="border-top: 2px #00ABD8 solid;">
            <!--begin::Header-->
            <div class="card-header pt-5">
                <!--begin::Title-->
                <h3 class="card-title align-items-start flex-column">
                    <span class="card-label fw-bolder text-dark">Ne Yapmalıyım ?</span>
               
                </h3>
                <!--end::Title-->
                <!--begin::Toolbar-->
                <div class="card-toolbar">
                    <span class="svg-icon svg-icon-2">
                        <i class="fas fa-book text-success" style="font-size: x-large;"></i>
                    </span>
                </div>
                <!--end::Toolbar-->
            </div>
            <!--end::Header-->
            <!--begin::Body-->
            <div class="card-body pt-0">
                <!--begin::Tab content-->
                <div class="d-flex align-items-center bg-light-warning rounded p-5 mb-7">
                    <!--begin::Icon-->
                    <span class="svg-icon svg-icon-warning me-5">
                        <!--begin::Svg Icon | path: icons/duotune/abstract/abs027.svg-->
                        <span class="svg-icon svg-icon-1">
                            <i class="fas fa-user text-success" style="font-size: larger;"></i>
                        </span>
                        <!--end::Svg Icon-->
                    </span>
                    <!--end::Icon-->
                    <!--begin::Title-->
                    <div class="flex-grow-1 me-2">
                        <a routerLink="/profil/{{this.kullanici.kullanici_id}}"  class="fw-bolder text-gray-800 text-hover-primary fs-6">Profil Bilgilerini Doğrula </a>             
                    </div>
                    <!--end::Title-->
                    <!--begin::Lable-->
                    <span class="fw-bolder text-warning py-1"></span>
                    <!--end::Lable-->
                </div>
                <div class="d-flex align-items-center bg-light-success rounded p-5 mb-7">
                    <!--begin::Icon-->
                    <span class="svg-icon svg-icon-success me-5">
                        <!--begin::Svg Icon | path: icons/duotune/abstract/abs027.svg-->
                        <span class="svg-icon svg-icon-1">
                            <i class="fas fa-phone-alt text-info" style="font-size: larger;"></i>
                        </span>
                        <!--end::Svg Icon-->
                    </span>
                    <!--end::Icon-->
                    <!--begin::Title-->
                    <div class="flex-grow-1 me-2">
                        <span class="fw-bolder text-gray-800  fs-6"> <a routerLink="/profil/{{this.kullanici.kullanici_id}}"  class="fw-bolder text-gray-800 text-hover-primary fs-6">
                            Telefon Bilgilerini Doğrula</a></span>
                        <span class="text-muted fw-bold d-block"></span>
                    </div>
                    <!--end::Title-->
                    <!--begin::Lable-->
                    <span class="fw-bolder text-success py-1"></span>
                    <!--end::Lable-->
                </div>

                <div class="d-flex align-items-center bg-light-danger rounded p-5 mb-7">
                    <!--begin::Icon-->
                    <span class="svg-icon svg-icon-danger me-5">
                        <!--begin::Svg Icon | path: icons/duotune/abstract/abs027.svg-->
                        <span class="svg-icon svg-icon-1">
                            <i class="fas fa-feather" style="font-size: large; color: red;"></i>
                        </span>
                        <!--end::Svg Icon-->
                    </span>
                    <!--end::Icon-->
                    <!--begin::Title-->
                    <div class="flex-grow-1 me-2">       
                       <a  *ngIf="oran==100; else text" (click)="talepSayisiKontrol()" class="fw-bolder text-gray-800 text-hover-primary fs-6 cursor-pointer">Talebini Yaz</a>
                       <ng-template #text>
                        <span class="fw-bolder text-gray-800  fs-6">Talebini Yaz</span>
                        <span class="text-muted fw-bold d-block">Profil bilgileriniz tamamlanmadan talepte bulunamazsınız.</span>
                       </ng-template>
                        
                    </div>
                    <!--end::Title-->
                    <!--begin::Lable-->
                    <span class="fw-bolder text-danger py-1"></span>
                    <!--end::Lable-->
                </div>

                <div class="d-flex align-items-center bg-light-info rounded p-5">
                    <!--begin::Icon-->
                    <span class="svg-icon svg-icon-info me-5">
                        <!--begin::Svg Icon | path: icons/duotune/abstract/abs027.svg-->
                        <i class="fas fa-hourglass-end" style="font-size: larger;color: #00A3CF;"></i>
                        <!--end::Svg Icon-->
                    </span>
                    <!--end::Icon-->
                    <!--begin::Title-->
                    <div class="flex-grow-1 me-2">
                        <a  routerLink="/talep-list" class="fw-bolder text-gray-800 text-hover-primary fs-6">Talep Sonucunu Takip Et</a>
                        <span class="text-muted fw-bold d-block"></span>
                    </div>
                    <!--end::Title-->
                    <!--begin::Lable-->
                    <span class="fw-bolder text-info py-1"></span>
                    <!--end::Lable-->
                </div>
                <!--end::Tab content-->
            </div>
            <!--end::Body-->
        </div>
        <!--end::Chart widget 8-->
    </div>
    <!--end::Col-->
</div>

</div>
</div>








